import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".drag-handle",
      animation: 150,
      ghostClass: "opacity-30",
      onEnd: this.onEnd.bind(this),
    });
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  onEnd() {
    const children = Array.from(this.element.children);
    const commentIds = children.map((el) => el.dataset.commentId);
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
      },
      body: JSON.stringify({ comment_ids: commentIds }),
    })
      .then((r) => r.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
